import React, { useEffect, useState } from 'react';
import ROUTERS from '../../../../commons/constans/router';
import RadioboxComponent from '../../../../commons/components/Forms/RadioboxComponent';
import TextInputComponent from '../../../../commons/components/Forms/TextInputComponent';
import {PRICE_PAY, STEPS} from '../../../../commons/constans/stepVideo';
import { currencyFormat, ploorPricePoint, priceFormat } from '../../../../utils/helpers';
import ButtonComponent from '../../../../commons/components/Forms/ButtonComponent';
import CouponSelector from '../../../../commons/components/Forms/CouponSelector';
import { usePoint } from '../../../../commons/customHooks/GiftBox';

type Props = {
  pushRoute: Function,
  pushDataVideoStepFour: Function,
  steps: Object,
  submitPayment: Function,
  removeCoupon: Function,
  coupon: Array,
  isShowTooltip: Boolean
  // point: any,
};

const Step4Component = ({
  pushRoute,
  pushDataVideoStepFour,
  steps,
  submitPayment,
  loadingSubmit = false,
  removeCoupon,
  coupon,
  isShowTooltip
  // point,
}: Props) => {

  const [ point ] = usePoint();

  const [dataStep4, setDataStep4] = useState({
    step_4: {
      payment_type: '1pay',
      current_point: +point || 0,
      use_point: 0,
      use_money: PRICE_PAY.ONE,
    },
  });

  
  const [valueIpt, setValueIpt] = useState(0);
  
  const [msgPoint, setMsgPoint] = useState(null);

  useEffect(() => {
    scrollTo(0, 0);
    setDataStep4({
      ...dataStep4,
      step_4: {
        ...steps.step_4,
        current_point: +point,
        use_point: steps.step_4?.coupon_id ? 0 : steps.step_4.use_point
      },
    });
  }, []);

  useEffect(() => {
    pushDataVideoStepFour(dataStep4, STEPS.FOUR);
  }, [dataStep4]);

  useEffect(() => {
    // console.log('point change');
    // setDataStep4({
    //   ...dataStep4,
    //   step_4: {
    //     ...steps.step_4,
    //     current_point: +point,
    //   },
    // });

    setDataStep4(p => ({
      step_4: {
        ...p.step_4,
        current_point: point
      },
    }));

  }, [point])

  useEffect(() => {
    const { step_4 } = dataStep4;
    if (step_4.use_point && step_4.coupon_id && step_4?.payment_type === '1pay') {
      setDataStep4(p => ({
        step_4: {
          ...p.step_4,
          coupon_id: null,
          coupon_message_id: null,
          coupon_selected: '',
          coupon_name: '',
          use_coupon: '',
        },
      }));
      removeCoupon();
    }
    // changeStypeInput(+dataStep4.step_4.use_point)
  }, [+dataStep4.step_4.use_point]);

  const handleChangePaymentType = (e) => {
    // document.getElementById('js-use-point').classList.remove('apply-point');
    // document.getElementById('js-parent-use-point').classList.remove('parent-apply-point');
    // document.getElementById('js-parent-use-point').classList.add('point');
    setDataStep4({
      ...dataStep4,
      step_4: {
        ...dataStep4.step_4,
        payment_type: e.target.value,
        use_point: 0,
        use_money: e.target.value == '2pay' ? PRICE_PAY.TWO : PRICE_PAY.ONE,
        coupon_id: null,
        coupon_message_id: null
      },
    });
  };

  const changeStypeInput = (pointFloor) => {
    if (pointFloor !== '' && pointFloor >= 1) {
      document.getElementById('js-use-point').classList.add('apply-point');
      document.getElementById('js-parent-use-point').classList.add('parent-apply-point');
      document.getElementById('js-parent-use-point').classList.remove('point');
    }else{
      document.getElementById('js-use-point').classList.remove('apply-point');
      document.getElementById('js-parent-use-point').classList.remove('parent-apply-point');
      document.getElementById('js-parent-use-point').classList.add('point');
    }
  }

  const handleApplyPoint = (point) => {
    let pointFloor = +ploorPricePoint(point)/1000;
    if (pointFloor < 1) {
      return;
    }
    // changeStypeInput(pointFloor)

    if (dataStep4?.step_4?.payment_type === '1pay') {
      setDataStep4({
        ...dataStep4,
        step_4: {
          ...dataStep4.step_4,
          use_point: pointFloor > PRICE_PAY.ONE ? PRICE_PAY.ONE : +pointFloor,
          use_money: +pointFloor > PRICE_PAY.ONE ? 0 : (PRICE_PAY.ONE - +pointFloor)
        },
      });
    }else{
      setDataStep4({
        ...dataStep4,
        step_4: {
          ...dataStep4.step_4,
          use_point: pointFloor > PRICE_PAY.TWO ? PRICE_PAY.TWO : +pointFloor,
          use_money: +pointFloor > PRICE_PAY.TWO ? 0 : (PRICE_PAY.TWO - +pointFloor)
        },
      });
    }
  };

  const handleChangePoint = (e) => {
    let value = e.target.value;
    let currentPoint = +ploorPricePoint(dataStep4?.step_4?.current_point)/1000;

    if (currentPoint < 1) {
      setMsgPoint('결제할 포인트가 부족합니다')
      setTimeout(() => {
        setMsgPoint(null)
      }, 3000)
      return;
    }
    setMsgPoint(null)
    // changeStypeInput(value)

    let pointChange = value.replace(/[^0-9]/g, '');

    if (dataStep4?.step_4?.payment_type === '1pay') {
        let use_point = 0;
        let use_money = 0;
        if (pointChange > currentPoint && currentPoint < PRICE_PAY.ONE) {
          use_point = currentPoint;
          use_money = PRICE_PAY.ONE - currentPoint;
        }else{
          use_point = +pointChange > PRICE_PAY.ONE ? PRICE_PAY.ONE : pointChange;
          use_money = +pointChange > PRICE_PAY.ONE ? 0 : PRICE_PAY.ONE - +pointChange;
        }
        setDataStep4({
          ...dataStep4,
          step_4: {
            ...dataStep4.step_4,
            use_point: +use_point,
            use_money: +use_money,
          },
        });
    }else{
      let use_point = 0;
      let use_money = 0;
      if (pointChange > currentPoint && currentPoint < PRICE_PAY.TWO) {
        use_point = currentPoint;
        use_money = PRICE_PAY.TWO - currentPoint;
      }else{
        use_point = +pointChange > PRICE_PAY.TWO ? PRICE_PAY.TWO : pointChange;
        use_money = +pointChange > PRICE_PAY.TWO ? 0 : (PRICE_PAY.TWO - +pointChange);
      }
      setDataStep4({
        ...dataStep4,
        step_4: {
          ...dataStep4.step_4,
          use_point: +use_point,
          use_money: +use_money
        },
      });
    }
  }

  // const onBlurInput = () => {
  //   setMsgPoint(null)
  // }

  const handleRemoveCoupon = () => {
    setDataStep4({
      step_4: {
        payment_type: steps.step_4.payment_type,
        current_point: steps.step_4.current_point,
        use_point: 0,
        coupon_id: null,
        coupon_message_id: null,
        coupon_selected: '',
        coupon_name: '',
        use_coupon: '',
      },
    });
    removeCoupon();
  };

  const renderCoupon = () => {
    console.log(dataStep4.step_4, 'renderCoupon');
    if (dataStep4.step_4 && dataStep4.step_4?.coupon_id) {
      return (
        <div className="coupon-image">
          <CouponSelector
            id={`${dataStep4.step_4?.coupon_selected.id}`}
            name={`input-coupon`}
            value={dataStep4.step_4?.coupon_selected?.coupon?.coupon_name || ''}
            path={dataStep4.step_4?.coupon_selected?.admin_id != null ? `/images/img_coupon02.svg` : `/images/img_coupon03_1.svg`}
            style={false}
            mutiple={false}
            close={true}
            data={dataStep4.step_4?.coupon_selected}
            handleRemoveCoupon={() => handleRemoveCoupon()}
          />
        </div>
      );
    } else {
      console.log('no');
      return <></>;
    }
  };

  const renderAmount = () => {
    let amount = PRICE_PAY.ONE;
    if (!dataStep4.step_4.coupon_id) {
      let point = dataStep4?.step_4?.use_point;
      let moneyCurrent = point && typeof point == 'string' ? point.split(',').join('') : point;
      moneyCurrent = moneyCurrent >= 1 ? moneyCurrent : 0;
      if (dataStep4?.step_4?.payment_type === '1pay') {
        let result = PRICE_PAY.ONE - +moneyCurrent;
        if (result > 0) {
          amount = `${priceFormat(result*1000)}원`;
        }else{
          amount = `0원`;
        }
      } else {
        let result = PRICE_PAY.TWO - +moneyCurrent;
        if (result > 0) {
          amount = `${priceFormat(result*1000)}원`;
        }else{
          amount = `0원`;
        }
      }
    } else {
      amount = `0원`;
    }

    return amount;
  };

  return (
    <>
      <h3>
        영상 제작을 위해 <span>결제를 진행</span>하세요!
      </h3>
      <div className="step-payment">
        <div className="form-group box-pay">
          <div className="form-group__label">
            <label className='pay'>결제 수량</label>{' '}
            {dataStep4.step_4.payment_type === '2pay' && (
              <span>남은 횟수는 영상 편지 무료 1회권으로 지급됩니다.</span>
            )}
          </div>
          <div className="input-group">
            <RadioboxComponent
              id={'js-1-pay'}
              name={'payment_type'}
              value={`1pay`}
              disabled={false}
              subTitle={'1회'}
              labelClass={'d-flex align-start'}
              checked={dataStep4.step_4?.payment_type === '1pay' ? true : false}
              handleChange={handleChangePaymentType}
            />
            <RadioboxComponent
              id={'js-2-pay'}
              name={'payment_type'}
              value={`2pay`}
              disabled={false}
              subTitle={'2회'}
              labelClass={'d-flex align-start'}
              checked={dataStep4.step_4?.payment_type === '2pay' ? true : false}
              handleChange={handleChangePaymentType}
            />
          </div>
        </div>
        {/* update */}
        {/* <div className="form-group">
          <div className="form-group__label">
            <label className='point'>포인트 사용 </label>
            <span>포인트는 1,000P 단위로만 사용 가능합니다.</span>
          </div>
          <div className="form-group__price">
            <div>
              <label>보유</label>
              <span>{priceFormat(+dataStep4.step_4?.current_point, 0)}P</span>
            </div>
            <div>
              <div className="input-component ">
                <label>사용</label>
                <div className="input-group point" id='js-parent-use-point'>
                  <input 
                    id={'js-use-point'}
                    name={'use_point'}
                    value={dataStep4.step_4.use_point || '' }
                    onChange={handleChangePoint}
                    disabled={dataStep4?.step_4?.current_point === 0 || dataStep4?.step_4?.coupon_id != null}
                    type="text"
                    // onBlur={onBlurInput}
                    autoComplete={`off`}
                    // placeHolder="0"
                  />
                  {msgPoint ? <small className="input-error show">{msgPoint}</small> : null}
                </div>
              </div>
              <div>
                <button
                  className="btn-use-point"
                  onClick={() =>
                    handleApplyPoint(dataStep4.step_4.current_point)
                  }
                  disabled={dataStep4?.step_4?.coupon_id != null}
                >
                  전액사용
                </button>
              </div>
            </div>
          </div>
        </div> */}
        
        {dataStep4.step_4.payment_type == '1pay' && 
          <div className="form-group coupon-box">
            <div className="form-group__prize">
              <label>쿠폰/이용권 사용</label>
              <button
                className=""
                onClick={() => pushRoute(ROUTERS.VIDEO_COUPON_BOX)}
              >
                쿠폰선택
              </button>
            </div>
            {
              dataStep4.step_4 && dataStep4.step_4?.coupon_id && <div className="marker-background mt-3">{renderCoupon()}</div>
            }
          </div>
        }
        <div className="step-payment__total">
          <span>총 결제 금액</span>
          <span>{renderAmount()}</span>
        </div>
        <div className="step-payment__button">
          {
            isShowTooltip && <div className='box-cancel-payment'>
              <div className='text'>
                <span>
                사용자에 의해 인앱결제가 취소되었습니다
                </span>
              </div>
            </div>
          }
          
          <ButtonComponent
            label={`결제하기`}
            customClass="btn btn-default"
            handleClick={() => submitPayment('payment')}
            type={`button`}
            // cssClass={`btn-custom`}
            style={{width: '100%'}}
            disabled={loadingSubmit || (dataStep4.step_4.use_point < 1 && dataStep4.step_4.use_point > 0)}
          />
        </div>
      </div>
    </>
  );
};

export default Step4Component;
